exports = module.exports = require("../../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._370CH{display:flex;padding:0;cursor:pointer;transition-duration:.2s;transition-property:opacity;opacity:1;border:0;border-radius:0;outline:none;background-color:transparent;justify-content:center;align-items:center}._370CH:hover{opacity:.7}._2dRNi{visibility:hidden!important;width:0!important;min-width:0!important;height:0!important;min-height:0!important;margin:0!important;padding:0!important;opacity:0!important}._2ZwzM{display:flex;flex:0 0 auto;height:25px;align-items:center}.FhZKL{font-size:12px;line-height:12px}div[data-playable-hook=player-container][data-playable-in-full-screen=true] .FhZKL{font-size:14px;line-height:14px}.udWVH{margin-left:5px}.udWVH:before{margin-right:4px;content:\"/\"}.N8Tow .udWVH,.N8Tow .kFUuV{display:none}", ""]);

// exports
exports.locals = {
	"controlButton": "_370CH",
	"hidden": "_2dRNi",
	"timeWrapper": "_2ZwzM",
	"time": "FhZKL",
	"duration": "udWVH",
	"liveMode": "N8Tow",
	"separator": "kFUuV"
};